module.exports = __webpack_public_path__ + "static/media/fo.b08620b3.svg";